<template>
    <div class="header-account__notification-content d-flex">
        <span v-if="hasUnreadNotifications" class="header-account__notification-has-new-notification">
            {{ numberOfNotifications }}
        </span>

        <div class="dropdown-remove-arrow dropdown-remove-padding d-flex">
            <b-dropdown ref="notificationDropdown" right :lazy="true">
                <template slot="button-content">
                    <span class="header-account__notification-link d-block" @click="fetchNotifications()">
                        <iconNotifications class="d-block" />
                    </span>
                </template>

                <b-dropdown-header>
                    <div class="row">
                        <div class="col-6">
                            <span class="dropdown-header__text">{{ $tc('notification', 2) }}</span>
                        </div>
                        <div class="col-6 text-right" @click="closeDropdown()">
                            <router-link
                                class="dropdown-header__link"
                                :to="{ name: $options.ROUTES_NOTIFICATION_SETTINGS }"
                            >
                                {{ $t('settings') }}
                            </router-link>
                        </div>
                    </div>
                </b-dropdown-header>

                <b-dropdown-group class="header-account__notification-dropdown-body">
                    <b-dropdown-text v-if="loading">
                        <div class="c_loading-over-content">
                            <loading />
                        </div>
                    </b-dropdown-text>

                    <b-dropdown-item
                        v-for="notification in notifications"
                        :key="notification.id"
                        class="header-account__notification-dropdown-body-item"
                        :class="{ 'is-unread-notification': notReadNotification(notification.read_at) }"
                    >
                        <span
                            class="header-account__notification-dropdown-body-text d-block"
                            @click="markAsRead(notification)"
                        >
                            {{ notification.body }}
                        </span>
                    </b-dropdown-item>

                    <b-dropdown-text
                        v-if="areEmptyNotifications"
                        class="header-account__notification-dropdown-empty-message d-block text-center"
                    >
                        {{ $t('thereAreNoNotifications') }}
                    </b-dropdown-text>
                </b-dropdown-group>

                <b-dropdown-text class="header-account__notification-dropdown-footer">
                    <div class="row">
                        <div class="col-6" @click="closeDropdown()">
                            <router-link
                                :to="{ name: $options.ROUTES_NOTIFICATIONS }"
                                class="header-account__notification-dropdown-see-all d-block"
                            >
                                {{ $t('seeAll') }}
                            </router-link>
                        </div>
                        <div class="col-6 text-right">
                            <a class="header-account__notification-dropdown-mark-all d-block" @click="markAllAsRead()">
                                {{ $t('markAllAsRead') }}
                            </a>
                        </div>
                    </div>
                </b-dropdown-text>
            </b-dropdown>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { DATE_FORMAT_API, TIME_FORMAT_LONG } from '@/constants/dateTimeFormats';
import { notificationsRoute } from '@/helpers/notificationsHelper';
import { ROUTES_HOME, ROUTES_NOTIFICATION_SETTINGS, ROUTES_NOTIFICATIONS } from '@/constants/routes';
import Loading from '@/components/helpers/Loading.vue';
import sessionMixin from '@/mixins/session';
import iconNotifications from '@/assets/img/account/header/notifications.svg?inline';

export default {
    mixins: [sessionMixin],

    components: {
        iconNotifications,
        Loading
    },

    ROUTES_HOME,
    ROUTES_NOTIFICATION_SETTINGS,
    ROUTES_NOTIFICATIONS,

    data() {
        return {
            notifications: []
        };
    },

    created() {
        this.getNumberOfUnreadNotifications();
    },

    methods: {
        ...mapActions({
            getNumberOfUnreadNotifications: 'clubHelper/getNumberOfUnreadNotifications',
            getNotifications: 'clubHelper/getNotifications'
        }),

        closeDropdown() {
            this.$refs.notificationDropdown.hide(true);
        },

        fetchNotifications(page = 1, limit = 20) {
            this.loading = true;
            return this.getNotifications({
                club_id: this.selectedClub.club_id,
                limit,
                page
            }).then(response => {
                this.notifications = response.data.data;
            }).catch(error => {
                this.$store.dispatch('notifyError', error);
                this.notifications = [];
            }).finally(() => {
                this.loading = false;
            });
        },

        notReadNotification(read_at) {
            return !read_at;
        },

        markAsRead(notification) {
            this.$store.dispatch('post', {
                url: api + 'notifications/mark-as-read',
                data: {
                    id: notification.id,
                    club_id: this.selectedClub.club_id
                }
            }).then(() => {
                Vue.set(notification, 'read_at', moment().format(`${DATE_FORMAT_API} ${TIME_FORMAT_LONG}`));
                this.$router.push(notificationsRoute(notification.type, notification.model_name, notification.model_id));
            }).catch(error => {
                this.$store.dispatch('notifyError', error);
            });
        },

        markAllAsRead() {
            this.$store.dispatch('post', {
                url: api + 'notifications/mark-all-as-read',
                data: {
                    club_id: this.selectedClub.club_id
                }
            }).then(() => {
                this.getNumberOfUnreadNotifications();
            });
        }
    },

    computed: {
        ...mapGetters({
            notificationsNumberOfUnread: 'clubHelper/numberOfUnreadNotifications',
            selectedClub: 'selectedClub'
        }),

        hasUnreadNotifications() {
            return this.notificationsNumberOfUnread > 0;
        },

        areEmptyNotifications() {
            return _.isEmpty(this.notifications);
        },

        numberOfNotifications() {
            return this.notificationsNumberOfUnread > 99 ? '99+' : this.notificationsNumberOfUnread;
        }
    }
};
</script>
